import React, { useEffect, useState, useCallback } from 'react';
import useApp from 'hooks/useApp'
import { Select, Logo, Layer } from 'components'
import styles from '../index.module.css'
import Lib from 'library'
import { financeSavingDetailState_3 } from './states'
import { useRecoilState } from 'recoil'

const FinanceSavingDetailLayer_3 = () => {

	const App = useApp()
	const [layerControl, setLayerControl] = useRecoilState(financeSavingDetailState_3)

	// const seq = layerControl.seq;
	// const dclsMonth = layerControl.dclsMonth;
	// const finCoNo = layerControl.finCoNo;
	// const finPrdtCd = layerControl.finPrdtCd;
	const aniId = layerControl.aniId; // 상품id
	
	// const auitSav = layerControl.auitSav;
	const [auitSav, setAuitSav] = useState(null); // 전체 데이터
	
	const [autySavOpLst, setAutySavOpLst] = useState(null);

	const [pnsnEntrAgeOption, setPnsnEntrAgeOption] = useState(null);
	const [monPaymAtmOption, setMonPaymAtmOption] = useState(null);
	const [paymPrdOption, setPaymPrdOption] = useState(null);
	const [pnsnStrtAgeOption, setPnsnStrtAgeOption] = useState(null);

	const [resultLst, setResultLst] = useState(null);

	const [pnsnEntrAge, setPnsnEntrAge] = useState(""); // 나이1
	const [monPaymAtm, setMonPaymAtm] = useState(""); // 매월 금액
	const [paymPrd, setPaymPrd] = useState(""); // 년도
	const [pnsnStrtAge, setPnsnStrtAge] = useState(""); //나이2

	const [accordionOpen, setAccordionOpen] = useState(true)
	const openAccordion = () => setAccordionOpen(!accordionOpen)

	const [isYear, setYear] = useState(null); // 올해

	const autySavRate = (data) => {
		// 연금가입나이
		const pnsnOptions = new Map(data.map(entr => [entr.pnsnEntrAge]));
		const _entrNm = [...pnsnOptions].map(([entr]) => ({ 'pnsn_entr_age': entr, 'pnsn_entr_age_nm': entr }));
		setPnsnEntrAgeOption(_entrNm);

		// 월 납입액
		const monOptions = new Map(data.map(mon => [mon.monPaymAtm,]));
		const _mon = [...monOptions].map(([atm]) => ({ 'mon_paym_atm': atm, 'mon_paym_atm_nm': atm }));
		setMonPaymAtmOption(_mon);
		// 납입기간
		const paymOptions = new Map(data.map(paym => [paym.paymPrd]));
		const _paym = [...paymOptions].map(([paym]) => ({ 'paym_prd': paym, 'paym_prd_nm': paym }));
		setPaymPrdOption(_paym);
		// 연금개시나이
		const strtOptions = new Map(data.map(strt => [strt.pnsnStrtAge]));
		const _strt = [...strtOptions].map(([strt]) => ({ 'pnsn_strt_age': strt, 'pnsn_strt_age_nm': strt }));
		setPnsnStrtAgeOption(_strt);


		setPnsnEntrAge(_entrNm[0].pnsn_entr_age);
		setMonPaymAtm(_mon[0].mon_paym_atm);
		setPaymPrd(_paym[0].paym_prd);
		setPnsnStrtAge(_strt[0].pnsn_strt_age);
	}

	// 연금 getAutySavDetailOption
	const getAutySavDetailOption = (aniId) => {
		Lib.myGet(`/api/recomm/annuity/v1/${aniId}`, (data) => {
			console.log('연금 : ', data.data)
			setAuitSav(data.data);
			setAutySavOpLst(data.data.options);
			autySavRate(data.data.options);
			// 올해계산
			setYear(new Date().getFullYear())
		});
	}
	useEffect(() => {
		layerControl.show && getAutySavDetailOption(aniId);
	}, [layerControl.show, aniId])
	// 원본
	// const getAutySavDetailOption = (month, codeNo, prdtCode) => {
	// 	Lib.post(`/api/finance/annuitySavingOption?dclsMonth=${month}&finCoNo=${codeNo}&finPrdtCd=${prdtCode}`, (data) => {
	// 		setAutySavOpLst(data);
	// 		autySavRate(data);
	// 	});
	// }

	// 상세보기시 기간, 금리가 안 보이는 오류가 있어서 매번 조회하도록 수정(layerControl.show 속성추가. 20221020)
	// useEffect(() => {
	// 	layerControl.show && getAutySavDetailOption(dclsMonth, finCoNo, finPrdtCd);
	// }, [layerControl.show, dclsMonth, finCoNo, finPrdtCd])

	const onResultSeleted = useCallback((key, value, set) => {
		set(value);
	}, [pnsnEntrAge, monPaymAtm, paymPrd, pnsnStrtAge]);

	useEffect(() => {
		const _selectedData = autySavOpLst && autySavOpLst.find(v => v.pnsnEntrAge === pnsnEntrAge && v.monPaymAtm === monPaymAtm && v.paymPrd === paymPrd && v.pnsnStrtAge === pnsnStrtAge);
		setResultLst(_selectedData);
	}, [pnsnEntrAge, monPaymAtm, paymPrd, pnsnStrtAge]);

	return (
		<Layer show={layerControl.show} closeLayer={() => setLayerControl(prev => ({ ...prev, show: false }))}>
			{
				auitSav &&
				<div className="page">
					<div className="shadow">
						<div className="padding">
							<div className="flex-justify_between align_center mt_10">
								<div className={styles["detail-title"]}>
									<span>{auitSav.korCoNm}</span>
									<p className="mt_5">{auitSav.finPrdtNm}</p>
									<i className="tag tag-box tag-blue mt_10">연금</i>
								</div>
								{/* <div className="img-box img-symbol img-symbol-lg ml_10">
									<Logo code={auitSav.fin_co_no} style={{ 'width': '6rem', 'height': '6rem' }} />
								</div> */}
							</div>
							<ul className={`${styles["count-list"]} mt_20`}>
								<li>
									<p>연평균 수익률</p>
									<strong>{Number(auitSav.avgPrftRate).toFixed(2)}%</strong>
								</li>
							</ul>
						</div>
					</div>
					<div className="shadow">
						<div className="padding">
							<div className={`${accordionOpen ? "active" : ""} accordion-title flex-justify_between align_center`} onClick={openAccordion}>
								<h3>내가 이 상품에 가입한다면?</h3>
								<i className="icon icon_accordion_arrow" />
							</div>
							<div className="accordion-content">
								<div className="flex-justify_center mt_40">
									<i className="icon icon_finance_saving" />
								</div>
								<div className={`${styles["question-area"]} mt_20`}>
									<div className={styles.sec}>{auitSav.finPrdtNm} 상품을</div>
									<div className={styles.sec}>
										<Select
											className="mr_10"
											title="연금 가입 연령"
											selected={pnsnEntrAge}
											data={pnsnEntrAgeOption && pnsnEntrAgeOption.map(entr => ({ key: `${entr.pnsn_entr_age_nm}세`, value: entr.pnsn_entr_age }))}
											onSelect={(key, value) => onResultSeleted(key, value, setPnsnEntrAge)}
										>
										</Select>
										<span className="mr_10">부터 매월</span>
										<Select
											className="mr_10"
											title="월 납입액"
											selected={monPaymAtm}
											data={monPaymAtmOption && monPaymAtmOption.map(mon => (
												{ key: `${mon.mon_paym_atm}만원`, value: mon.mon_paym_atm }
											))}
											onSelect={(key, value) => onResultSeleted(key, value, setMonPaymAtm)}
										>
										</Select>
										씩
									</div>
									<div className={styles.sec}>
										<Select
											className="mr_10"
											title="납입기간"
											selected={paymPrd}
											data={paymPrdOption && paymPrdOption.map(paym => (
												{ key: `${paym.paym_prd_nm}년`, value: paym.paym_prd }
											))}
											onSelect={(key, value) => onResultSeleted(key, value, setPaymPrd)}
										>
										</Select>
										<span className="mr_10">납입해서</span>
										<Select
											className="mr_10"
											title="연금 개시연령"
											selected={pnsnStrtAge}
											data={pnsnStrtAgeOption && pnsnStrtAgeOption.map(strt => (
												{ key: `${strt.pnsn_strt_age_nm}세`, value: strt.pnsn_strt_age }
											))}
											onSelect={(key, value) => onResultSeleted(key, value, setPnsnStrtAge)}>
										</Select>
										에 연금을 받을 경우
									</div>
								</div>
								<div className={`${styles["answer-box"]} mt_20`}>
									{resultLst && <>
										<strong>
										{/* 연금수령기간(A -> 10년, B -> 20년, C -> 종신남자10년보증, D -> 종신여자10년보증) */}
											{resultLst.pnsnRecpTrm === "A" && "10년"}
											{resultLst.pnsnRecpTrm === "B" && "20년"}
											{resultLst.pnsnRecpTrm === "C" && "종신남자10년보증"}
											{resultLst.pnsnRecpTrm === "D" && "종신여자10년보증"}
										</strong>
										동안 <strong>{Lib.addComma(resultLst.pnsnRecpAmt)}원</strong> 받을수 있어요!
									</>}
								</div>
							</div>
						</div>
					</div>
					<div className="padding">
						<ul className="list-item list-item-left" style={{ fontSize: "1.2rem" }}>
						    {
                                ( auitSav.pnsnKindNm != 'null' &&  auitSav.pnsnKindNm != "-" ) &&
                                <li>
                                    <span>연금 종류</span>
                                    <span>{auitSav.pnsnKindNm}</span>
                                </li>
							}
							{
                                ( auitSav.prdtTypeNm != 'null' &&  auitSav.prdtTypeNm != "-" ) &&
                                <li>
                                    <span>상품유형</span>
                                    <span>
                                        {auitSav.prdtTypeNm}
                                    </span>
                                </li>
                            }
                            {
                                ( auitSav.dclsRate != "null" && auitSav.dclsRate != "-" ) &&
                                <li>
                                    <span>공시이율</span>
                                    <span>{auitSav.dclsRate}%</span>
                                </li>
                            }
							{
							    ( auitSav.btrmPrftRate1 != 'null' && auitSav.btrmPrftRate1 != "-" ) &&
                                <li>
                                    <span>{isYear-1}년 수익율</span>
                                    <span>
                                        <div style={{ whiteSpace: "pre-wrap" }}>
                                            {auitSav.btrmPrftRate1}
                                        </div>
                                    </span>
                                </li>
                            }
                            {
                                ( auitSav.btrmPrftRate2 != 'null'  &&  auitSav.btrmPrftRate2 != "-" ) &&
                                <li>
                                    <span>{isYear-2}년 수익율</span>
                                    <span>
                                        <div style={{ whiteSpace: "pre-wrap" }}>
                                            {auitSav.btrmPrftRate2}
                                        </div>
                                    </span>
                                </li>
							}
							{
                                ( auitSav.btrmPrftRate3 != 'null' && auitSav.btrmPrftRate3 != "-" ) &&
                                <li>
                                    <span>{isYear-3}년 수익율</span>
                                    <span>
                                        <div style={{ whiteSpace: "pre-wrap" }}>
                                            {auitSav.btrmPrftRate3}
                                        </div>
                                    </span>
                                </li>
							}
							{
                                ( auitSav.guar_rate && auitSav.guar_rate != 'null' && auitSav.guar_rate != "" ) &&
                                <li>
                                    <span>최저 보증이율</span>
                                    <span>
                                        <div style={{ whiteSpace: "pre-wrap" }}>
                                            {auitSav.guar_rate}
                                        </div>
                                    </span>
                                </li>
                            }
							{
                                ( auitSav.etc != 'null' && auitSav.etc != "" ) &&
                                <li>
                                    <span>기타사항</span>
                                    <span style={{ whiteSpace: "pre-wrap" }}>{auitSav.etc}</span>
                                </li>
							}
							{
                                ( auitSav.saleCo != 'null' && auitSav.saleCo != "" ) &&
                                <li>
                                    <span>판매사</span>
                                    <span style={{ whiteSpace: "pre-wrap" }}>{auitSav.saleCo}</span>
                                </li>
                            }
                            {
                                ( auitSav.saleStrtDay != 'null' && auitSav.saleStrtDay != "-" ) &&
                                <li>
                                    <span>판매 개시일</span>
                                    <span>{auitSav.saleStrtDay}</span>
                                </li>
                            }
                            {
                                ( auitSav.dclsStrtDay != 'null' || auitSav.dclsEndDay != null ) &&
                                <li>
                                    <span>공시 기간</span>
                                    <span>{auitSav.dclsStrtDay} ~ {auitSav.dclsEndDay}</span>
                                </li>
							}
						</ul>
						<div className={`${styles["list-guide"]} mt_50`}>금융감독원의 금융상품 API를 통해 제공하는 정보입니다.</div>
					</div>
				</div>
			}
		</Layer>
	)
}

export default FinanceSavingDetailLayer_3